module.exports = __webpack_public_path__ + "img/drt17.944b6c7b.png";